import { render, staticRenderFns } from "./sp-setting-drawer.vue?vue&type=template&id=5828b4a5"
import script from "./sp-setting-drawer.vue?vue&type=script&lang=ts"
export * from "./sp-setting-drawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VNavigationDrawer,VToolbar})
